module.exports = __webpack_public_path__ + "static/media/countries.9282a06f.geojson";